/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminGetCustomerInvolvedContributionHistoryRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {AdminGetCustomerInvolvedContributionHistoryResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const adminGetCustomerInvolvedContributionHistory = (request:AdminGetCustomerInvolvedContributionHistoryRequest, options?: CashRequestOptions) => post<AdminGetCustomerInvolvedContributionHistoryRequest, AdminGetCustomerInvolvedContributionHistoryResponse>("/2.0/cash/admin-get-customer-involved-contribution-history", request, {...options, rejectOnError: true })